import React, { Component } from 'react';
import "core-js/stable";
import "regenerator-runtime/runtime";

const Modal = require('../../../deploynaut/js/Modal.jsx');
const form = require('../../../deploynaut/js/Form.jsx');

class AccountResetModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			SecurityID: this.props.securityID
		};
	}

	render() {
		return (
			<Modal
				closeHandler={this.props.closeHandler}
				closeTitle="&#215;"
				title="Reset account"
				large={false}
			>
				<form.Form
					ref="accountResetForm"
					url={this.props.model.AccountResetURL}
					securityID={this.state.SecurityID}
					buttonTitle="Send user account reset email"
					buttonSubmittingTitle="Sending..."
					afterSuccess={this.props.closeHandler}
				>
					<strong>Help user reset their password and multi-factor authentication</strong>
					<p>
						Ensure that the person requesting a reset is the real person associated to this account before proceeding.
						An email will be sent to the their address with a link to reset both their password and multi-factor authentication methods.</p>

					<form.Hidden name="ID" value={this.props.user} />
				</form.Form>
			</Modal>
		);
	}
}

module.exports = AccountResetModal;
